import React from 'react';
import {Card} from 'semantic-ui-react';

const ServiceCard = ({data}) => {
    return (
        <div className="service_card">
        <Card>
            <img src={data['profile']} className="service_card_img" alt="Loading..." />
            <Card.Content>
            <Card.Header>{data['name']}</Card.Header>
            <Card.Description>
                {data['description']}
            </Card.Description>
            </Card.Content>
        </Card>
        </div>
    )
};

export default ServiceCard;